if (!customElements.get('wlsn-counter')) {
  class WLSNCounter extends HTMLElement {
    constructor() {
      super();

      const rawDateTime = this.dataset.date; // Format: '12-05-2024:00:00'
      const dateTimeRegex = /^(\d{2})-(\d{2})-(\d{4}):(\d{2}):(\d{2})$/;
      const dateTimeParts = rawDateTime.match(dateTimeRegex);

      if (!dateTimeParts) {
        console.error("Invalid date format. Expected: mm-dd-yyyy:hh:mm. Got:", rawDateTime);
        return;
      }

      const [_, month, day, year, hours, minutes] = dateTimeParts.map(Number);

      const formattedDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}T${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:00`;

      this.endDate = new Date(formattedDate);
      this.classes = {
        active: 'active',
        time: 'js-wlsn-counter-time',
      };

      this.elements = {
        time: this.querySelector(`.${this.classes.time}`),
      };

      this.timeZone = 'America/New_York';
    }

    /**
     * Connected callback lifecycle method
     * @returns {void}
     */
    connectedCallback() {
      this.timer = setInterval(() => this._initCounter(), 1000);
      this._initCounter();
    }

    /**
     * Disconnected callback lifecycle method
     * @returns {void}
     */
    disconnectedCallback() {
      clearInterval(this.timer);
    }

    /**
     * Get current time in New York timezone
     * @returns {Date} - Current date/time in NY timezone
     */
    _getCurrentTimeInNY() {
      const now = new Date();
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: this.timeZone,
        hour12: false,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });

      const parts = formatter.formatToParts(now);
      const [month, day, year, hours, minutes, seconds] = [
        parts.find((p) => p.type === 'month').value,
        parts.find((p) => p.type === 'day').value,
        parts.find((p) => p.type === 'year').value,
        parts.find((p) => p.type === 'hour').value,
        parts.find((p) => p.type === 'minute').value,
        parts.find((p) => p.type === 'second').value,
      ];

      return new Date(`${year}-${month}-${day}T${hours}:${minutes}:${seconds}`);
    }

    /**
     * Initialize and update counter display
     * @returns {void}
     */
    _initCounter() {
      if (!this.elements.time) return;
      this.elements.time.classList.add(this.classes.active);

      const nowNY = this._getCurrentTimeInNY();
      let timeRemaining = this.endDate - nowNY;

      if (timeRemaining <= 0) {
        clearInterval(this.timer);
        this.elements.time.innerText = "Time's up!";
        return;
      }

      const units = {
        days: 1000 * 60 * 60 * 24,
        hours: 1000 * 60 * 60,
        minutes: 1000 * 60,
        seconds: 1000,
      };

      const pad = (num) => String(num).padStart(2, '0');

      const data = Object.keys(units).reduce((acc, unit) => {
        acc[unit] = Math.floor(timeRemaining / units[unit]);
        timeRemaining %= units[unit];
        return acc;
      }, {});

      this.elements.time.innerText = Object.keys(units)
          .map((unit) => pad(data[unit]))
          .join(':');
    }
  }

  customElements.define('wlsn-counter', WLSNCounter);
}
